import { Switch, Icon } from "@elaniintc/goes-design-system";

function cn(...classes: (string | false | undefined)[]) {
  return classes.filter(Boolean).join(" ");
}

interface SwitchFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  isTrue?: string;
  isFalse?: string;
  switchVariant?: "default" | "danger" | null | undefined; // danger variant user for data center node operations
}

const SwitchField = ({
  label,
  required = false,
  error,
  helperText,
  checked,
  onChange,
  disabled = false,
  id,
  isTrue = "Si",
  isFalse = "No",
  switchVariant = "default",
}: SwitchFieldProps) => {
  return (
    <div className="flex flex-col gap-1">
      <label
        className={cn(
          "font-semibold text-body-loud leading-2xl",
          disabled && "!text-on-disabled",
        )}
        htmlFor={id}
      >
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div className="flex items-center gap-3 mt-1">
        <Switch
          id={id}
          checked={checked}
          onCheckedChange={onChange}
          disabled={disabled}
          variant={switchVariant}
        />
        <span
          className={cn(
            "text-body font-normal",
            disabled && "!text-on-disabled",
          )}
        >
          {checked ? isTrue : isFalse}
        </span>
      </div>
      <div className="flex flex-col gap-0.5 mt-1">
        <div className="flex items-center justify-between gap-3">
          <div>
            {!error && helperText && (
              <p className="text-xs leading-xl text-body-quiet">{helperText}</p>
            )}
            {error && (
              <p className="text-danger text-xs leading-xl font-normal">
                <Icon type="far" name="circle-xmark" className="mr-1.5" />
                {error}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SwitchField;
